import Echo from 'laravel-echo'

window.io = require('socket.io-client')

const ECHO_SERVER = process.env.VUE_APP_MPP_API_ECHO_SERVER

export default new Echo({
    broadcaster: 'socket.io',
    host: ECHO_SERVER
});